import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/wishlist").then((r) => setRows(r.data)); }, []);
  return (
    <div className="blz-container py-10">
      <h1 className="font-display text-3xl font-bold">Your wishlist</h1>
      {rows.length === 0 ? (
        <div className="text-slate-500 mt-4">No saved items yet.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-6">
          {rows.map((p) => <ProductCard key={p.id} product={p}/>)}
        </div>
      )}
    </div>
  );
}
